import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '../../../../components/directives.module';
import { ComingInstantCheckupListComponent } from './coming-instant-checkup-list.component';

const ROUTES: Routes = [
  { path: '', component: ComingInstantCheckupListComponent, pathMatch: 'full' },
];

@NgModule({ imports: [
  CommonModule,
  FormsModule,
  AgGridAngular,
  DirectivesModule,
  MomentModule,
  RouterModule.forChild(ROUTES),
],
declarations: [ComingInstantCheckupListComponent],
exports: [ComingInstantCheckupListComponent] })
export class ComingInstantCheckupListModule {}
